import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

type ScreenOrientation = 'portrait' | 'landscape';

const getScreenOrientation = () => (window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');

const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<ScreenOrientation>(getScreenOrientation());
  const handleResize = debounce(() => setOrientation(getScreenOrientation()), 250);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return orientation;
};

export default useScreenOrientation;
